import React from "react";
import { connect } from "react-redux";
import { ProfileInstrumentDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
// import { toast } from "react-toastify";
import { Buttons, Cards, Displays } from "components";
class ProfileInstrumentDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let resArr = await Promise.all([
      userService.GET_INSTRUMENT_DETAIL(router.params?.id),
      userService.GET_MY_INSTRUMENT_DETAIL(router.params?.id, "2"),
    ]);
    if (resArr) {
      const reduce = resArr[1].data.reduce(
        (result, data) => {
          if (data.status !== "1") {
            result.maintenanceInstrumentList.push(data);
          }
          if (data.status === "1") {
            result.maintenanceInstrumentLatest = data;
          }
          return result;
        },
        {
          maintenanceInstrumentList: [],
          maintenanceInstrumentLatest: false,
        }
      );
      let resReward = reduce.maintenanceInstrumentLatest
        ?.reward_e_voucher_ref_id
        ? await userService.GET_REWARD_E_VOUCHER_DETAIL(
            reduce.maintenanceInstrumentLatest.reward_e_voucher_ref_id
          )
        : { data: false };
      if (resReward) {
        this.setState({
          productWarrantyDetail: resArr[0].data,
          maintenanceInstrumentList: reduce.maintenanceInstrumentList,
          maintenanceInstrumentLatestDetail: reduce.maintenanceInstrumentLatest,
          promotionDetail: resReward.data,
          isLoading: false,
        });
      }
    }
    // const { router, t } = this.props;
    // let res = await userService.GET_PRODUCT_WARRANTEE_ACTIVE_BY_SN(
    //   router.params?.id
    // );
    // if (res && res.status === 200) {
    //   this.setState({
    //     data: res.data,
    //     isLoading: false,
    //     isBgLoading: false,
    //   });
    // } else {
    //   toast.error(t("Incorrect serial number", { ns: "common" }));
    //   this.setState({
    //     step: 1,
    //   });
    // }
  };

  // STEP 1 CHOOSE MEMBER TYPE
  // ==================================
  // ==================================
  handleSubmitStep1 = (e) => {
    // const { router } = this.props;
    // if (!router.params?.id || router.params?.id === "register") {
    //   this.setState({
    //     step: 2,
    //     isLoading: false,
    //   });
    // } else {
    //   this.setState({
    //     isLoading: true,
    //     step: 3,
    //   });
    //   this.fetchData();
    // }
  };

  handleNextStep = () => {
    const { router } = this.props;
    this.props.router.navigate(
      `${ROUTE_PATH.PRODUCT_WARRANTEE}/${router.params?.id}/success`
    );
  };

  render() {
    const { t, router } = this.props;
    const {
      isLoading,
      isBgLoading,
      productWarrantyDetail,
      maintenanceInstrumentList,
      maintenanceInstrumentLatestDetail,
      promotionDetail,
    } = this.state;
    return (
      <ProfileInstrumentDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <>
            <div className="product_info_layout">
              <Cards.ProductInstrument {...productWarrantyDetail} />
            </div>
            {maintenanceInstrumentLatestDetail && (
              <div className="booking_layout">
                <Cards.MyInstumentTuneBooking
                  {...maintenanceInstrumentLatestDetail}
                />
              </div>
            )}
            {promotionDetail && <Cards.PromotionPackage {...promotionDetail} />}
            {maintenanceInstrumentList && (
              <div className="promo_tune_wrap">
                <Cards.InstumentTune data={maintenanceInstrumentList} />
              </div>
            )}
            <div className="btn_wrap">
              <Buttons.BgStandard
                label={t("Back", { ns: "common" })}
                onClick={() => router.navigate(-1)}
              />
            </div>
          </>
        )}
      </ProfileInstrumentDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["common"])(withRouter(ProfileInstrumentDetailContainer)));
